import { useLocation } from "react-router-dom";

import { Image, NavbarRoute, LogOutButton } from "components/atoms";

import { NavRoute } from "models/routes";

import { navRoutes } from "utils/routes";

import { SIZES } from "styles/size";

import logoSm from "assets/images/logoSm.svg";
import logo from "assets/images/logo.svg";

interface Props {
	isExpanded: boolean;
}

const Navbar = (props: Props): JSX.Element => {
	const location = useLocation();

	const { isExpanded } = props;

	const renderRoutes = () =>
		navRoutes.map((route: NavRoute) => {
			const isActive =
				location.pathname === route.to ||
				location.pathname.startsWith(`${route.to}/`);

			return (
				<NavbarRoute
					route={route}
					key={route.to}
					isActive={isActive}
					isExpanded={isExpanded}
				/>
			);
		});

	return (
		<div
			className="h-screen p-2 bg-[hsl(var(--sidebar-background))] z-[1] transition-[width] duration-[250ms] ease relative flex flex-col gap-1"
			style={{
				width: isExpanded
					? `${SIZES.EXPANDED_NAVBAR_WIDTH}px`
					: `${SIZES.NAVBAR_WIDTH}px`,
			}}
		>
			<div className="w-full flex justify-center mb-4 py-3 h-11 invert dark:invert-0">
				<Image
					src={isExpanded ? logo : logoSm}
					width={
						isExpanded
							? SIZES.EXPANDED_NAVBAR_LOGO_WIDTH
							: SIZES.NAVBAR_LOGO_WIDTH
					}
				/>
			</div>
			{renderRoutes()}
			<div className="mt-auto w-full">
				<LogOutButton isExpanded={isExpanded} />
			</div>
		</div>
	);
};

export default Navbar;
